import { render, staticRenderFns } from "./renewBox.vue?vue&type=template&id=4a64ca18&"
import script from "./renewBox.vue?vue&type=script&lang=js&"
export * from "./renewBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports